module.exports = __webpack_public_path__ + "static/img/icon-4.550c545.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-4.png
// module id = ufEw
// module chunks = 1 3 4 5 6 7